import { PRIMARY } from '../../styles';

export default {
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PRIMARY,
    height: '100vh',
    backgroundImage: `url(/images/tile.png)`,
    backgroundRepeat: 'repeat',
  },
  email: {},
  password: {},
  login: {
    margin: 5,
  },
  register: {
    margin: 5,
  },
  forgotPass: {},
  paper: {
    padding: 30,
    minWidth: 350,
  },
  message: {
    padding: 10,
  },
  buttons: {
    minWidth: 150,
    maxWidth: 200,
  },
  button: {
    minWidth: 150,
    maxWidth: 200,
  }
};



// WEBPACK FOOTER //
// ./src/components/Authentication/Login/styles.js